import { Layout } from '@app/layout/Layout'
import { ErrorPage } from '@pages/errorPage'
import { routes } from '@shared/constants/constants'
import { importNamedComponent } from '@shared/helpers/helpers'
import { createBrowserRouter } from 'react-router-dom'

const HomePage = importNamedComponent(() => import('@pages/homePage'), 'HomePage')
const KitAwardPage = importNamedComponent(() => import('@pages/kitAwardsPage'),'KitAwardPage')
const RegistrationPage = importNamedComponent(() => import('@pages/registrationPage'),'RegistrationPage')
const SpeakersPage = importNamedComponent(() => import('@pages/speakersPage'),'SpeakersPage')
const NotFound = importNamedComponent(() => import('@pages/notFoundPage'),'NotFound')

export const router = createBrowserRouter([
  {
    element:<Layout/>,
    errorElement:<ErrorPage/>,
    children: [
      {
        path: routes.home,
        element:<HomePage/>
      },
      {
        path:routes.registration,
        element:<RegistrationPage/>
      },
      {
        path:routes.kitAward,
        element:<KitAwardPage/>
      },
      {
        path:routes.kitAwardId,
        element:<KitAwardPage/>
      },
      {
        path :routes.speakers,
        element: <SpeakersPage/>,
      },
      {
        path: routes.notFound,
        element: <NotFound/>,
      },
    ]
  }
])
